import { addClass, removeClass } from '../dom';
export function removeEnterAnimation(node, enteredClassName) {
    if (!node) {
        return;
    }
    removeClass(node, enteredClassName);
}
export function addEnterAnimation(node, enteredClassName) {
    if (!node) {
        return;
    }
    var callback = function (e) {
        removeEnterAnimation(node, enteredClassName);
        node.removeEventListener('animationend', callback);
        node.removeEventListener('animationcancel', callback);
    };
    node.addEventListener('animationend', callback);
    node.addEventListener('animationcancel', callback);
    addClass(node, enteredClassName);
}
//# sourceMappingURL=helpers.js.map